import React, { useEffect, useState } from 'react';
import Header from '../components/header';
import CustomButton from '../../components/customButton';
import Materiel from './materiel/materiel';
import { ToastContainer } from 'react-toastify';
import Consommable from './consommables/consommable';
import Departement from './departements/departement';
import Commentaire from './commentaires/commentaire';
import axios from 'axios';
import getEnvironement from '../../environnement';
import { useSelector } from 'react-redux';
import { userSelector } from '../../store/userSlice';
import { useNavigate } from 'react-router-dom';

export default function Configurations() {
  const [activeTab, setActiveTab] = useState(1);

  const [badgeNotification, setBadgeNotification] = useState(0);
  const [reservationsNotification, setReservationsNotification] = useState([]);
  const [messagesNotification, setMessagesNotification] = useState([]);

  const user = useSelector(userSelector);
  const navigate = useNavigate();

  const tabs = [
    {id: 1, tab: 'matériels'},
    {id: 2, tab: 'consommables'},
    {id: 3, tab: 'départements'},
    {id: 4, tab: 'commentaires'},
  ]

  function getContent() {
    switch (activeTab) {
      case 1: return <Materiel />;
      case 2 : return <Consommable />;
      case 3 : return <Departement />
      case 4 : return <Commentaire />
      default: return <div />;
    }
  }

  async function getNotificationData() {
    const url = `${getEnvironement().API_URL}/notificationData`;
    await axios.post(url)
      .then((res) => {
        setReservationsNotification(res.data.reservations);
        setMessagesNotification(res.data.messages);
      })
      .then(() => setBadgeNotification(reservationsNotification.length + messagesNotification.length))
      .catch(() => {});
  }

  useEffect(() => {
    setBadgeNotification(reservationsNotification.length + messagesNotification.length);
  }, [reservationsNotification, messagesNotification]);

  useEffect(() => {
    getNotificationData();
  }, []);

  useEffect(() => {
      if (user === null) {
        navigate('/admin');
      }
    }, [navigate, user]);
  return (
    <div className='h-screen flex flex-col'>
      <ToastContainer />
      <div className='h-38'>
        <Header
          activeItem='Configurations'
          reservations={reservationsNotification}
          messages={messagesNotification}
          badgeNotification={badgeNotification}
        />
      </div>
      <div className='w-full 3xl:flex 3xl:justify-center flex-grow'>
        <div className='3xl:w-[1200px] px-10 py-5 3xl:py-5 3xl:px-0 h-full flex flex-col justify-center'>
          <div className='flex flex-col xl:flex-row xl:justify-between xl:gap-5 w-full'>
            {tabs.map((item) => {
              return (
                <CustomButton
                  value={item.tab}
                  outlined={activeTab !== item.id}
                  admin
                  handelClick={() => setActiveTab(item.id)}
                />
              );
            })}

          </div>
          {getContent()}
        </div>
      </div>
    </div>
  );
}
